import { Filter } from './filter';

export class FilterGroup {
  Filters: Filter[];
  FilterGroups: FilterGroup[];
  And: boolean;

  constructor() {
    this.Filters = [];
    this.FilterGroups = [];
    this.And = true;
  }
}
